export default __webpack_public_path__ + "static/media/hidraulic3.8b96b5f6.jpeg";